<mat-expansion-panel #panel
                    [class.detect-group--hidden]="!visible()"
                    [expanded]="expanded()"
                    hideToggle>

  <mat-expansion-panel-header>
    <div class="d-flex align-items-center gap-2 w-100 py-1" >

      <!-- Chevron — rotates with expanded state -->
      <mat-icon class="flex-shrink-0"
                [style.transform]="panel.expanded ? 'rotate(0deg)' : 'rotate(-90deg)'">
        expand_more
      </mat-icon>

      <!-- Color picker -->
      <lib-color-swatch-picker
        class="flex-shrink-0"
        [color]="object().color"
        [size]="14"
        [ariaLabel]="'Change color for ' + object().name"
        (colorApply)="changeColor($event)"
        (click)="$event.stopPropagation()" />

      <!-- Name + subtext — constrained to available space -->
      <div class="flex-fill overflow-hidden">
        <div class="mat-font-body-md fw-semibold text-truncate">
          {{ object().name }}
        </div>
        <div class="mat-font-body-sm text-truncate">
          {{ result().detections.length }} detected
        </div>
      </div>
      <!-- Download this layer -->
      <button matIconButton
              type="button"
              class="flex-shrink-0 mat-icon-button-medium"
              [attr.aria-label]="'Export ' + object().name"
              (click)="openExport($event)">
        <mat-icon>download</mat-icon>
      </button>

      <!-- Bbox visibility toggle -->
      <button matIconButton
              type="button"
              class="flex-shrink-0 mat-icon-button-medium"
              [matTooltip]="bboxVisible() ? 'Hide bounding boxes' : 'Show bounding boxes'"
              (click)="toggleBboxes($event)">
        <mat-icon [style.color]="bboxVisible() ? 'var(--mat-sys-primary)' : 'var(--mat-sys-outline)'">
          select_all
        </mat-icon>
      </button>

      <!-- Mask visibility toggle -->
      <button matIconButton
              type="button"
              class="flex-shrink-0 mat-icon-button-medium"
              [matTooltip]="maskVisible() ? 'Hide masks' : 'Show masks'"
              (click)="toggleMasks($event)">
        <mat-icon [style.color]="maskVisible() ? 'var(--mat-sys-primary)' : 'var(--mat-sys-outline)'">
          gradient
        </mat-icon>
      </button>

    </div>
  </mat-expansion-panel-header>

  <!-- Expanded body -->
  <div class="pt-1 pb-2">

    <!-- Compact sort pills -->
    <div class="d-flex align-items-center gap-1 mb-2 flex-wrap">
      <span class="mat-font-label-sm text-uppercase fw-semibold flex-shrink-0">
        Sort
      </span>
      @for (s of sortOptions; track s.value) {
        <button type="button"
                class="sort-pill"
                [class.sort-pill--active]="sortMode() === s.value"
                (click)="sortMode.set(s.value)">
          {{ s.label }}
        </button>
      }
    </div>

    <!-- Detection card grid — 2 columns -->
    @if (sortedItems().length === 0) {
      <p class="mat-font-body-sm text-center py-3 mb-0">
        No detections for this type.
      </p>
    } @else {
      <div class="d-flex flex-column gap-2">
        @for (item of sortedItems(); track item.displayIndex) {
          <div class="position-relative">
            <app-search-result-card
              [item]="toSearchItem(item)"
              [index]="item.displayIndex - 1"
              [imageHeight]="300"
              [imageWidth]="300"
              [showFeedback]="false"
              [showBbox]="bboxVisible()"
              [showMask]="maskVisible()"
              [maskColor]="object().color"
            />
            @if (debugMergedVisible() && (item.mergedFrom?.length ?? 0) >= 2) {
              <span class="detect-merged-badge mat-font-label-sm fw-semibold position-absolute px-2 py-1 rounded-pill">
                merged from {{ item.mergedFrom!.length }}
              </span>
            }
          </div>
        }
      </div>
    }

  </div>
</mat-expansion-panel>
